module.exports = __webpack_public_path__ + "static/media/design_guideline_light.40f04476.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/gtmobile/src/design_guideline_light.png
// module id = 523
// module chunks = 0